var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"margin-bottom":"100px"}},[_c('Header',{attrs:{"name":"","navLinks":[
        {
          name: 'Home',
          link: '/',
          dropdown: false
        },
        { name: 'Students', link: '/students', dropdown: false },
        { name: 'Calculator', link: '/calculator', dropdown: false },
        { name: 'Bitcoin (Api)', link: '/bitcoin', dropdown: false },
        { name: 'To Do', link: '/todolist', dropdown: false },
        { name: 'To Do (Api)', link: '/todolistapi', dropdown: false },
        { name: 'ECommerce', link: '/ecommerce', dropdown: false },
        { name: 'Currency Convertor', link: '/currency', dropdown: false },
        { name: 'Endgame', link: '/battle', dropdown: false }
      ]}})],1),_c('router-view'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }